import { useState, useCallback, useMemo } from "react";
import { Box, Container } from "@chakra-ui/react";
import AffiliateTransactions from "components/AffiliateTransactions/AffiliateTransactions";
import AffiliateWallet from "components/AffiliateWallet/AffiliateWallet";
import { useHistory } from "react-router-dom";

import {
  useGetAffiliateEarningSummaryQuery,
  useGetAffiliateTransactionsQuery,
} from "services/walletApi";
import { toQueryString } from "util/utils";

export default function CryptoDetailsAffiliates({ coin }) {
  const history = useHistory();

  const [state, _setState] = useState({
    page: 1,
    limit: 10,
    unit: coin,
  });

  const setState = useCallback(
    (newState) => _setState(() => ({ ...state, ...newState })),
    [state]
  );

  const queries = useMemo(() => toQueryString(state), [state]);

  const { data: summaryData /*isLoading: isSummaryLoading*/ } =
    useGetAffiliateEarningSummaryQuery();

  const { data, isLoading, isFetching } =
    useGetAffiliateTransactionsQuery(queries);

  const earnings = useMemo(() => data?.earnings, [data]);
  const totalCount = useMemo(() => data?.totalCount, [data]);

  const combinedEarns = useMemo(
    () => summaryData?.combinedEarns,
    [summaryData]
  );

  const balance = useMemo(
    () => combinedEarns && combinedEarns[coin],
    [combinedEarns, coin]
  );

  console.log("summary", summaryData);

  return (
    <Container
      maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
      m="0"
      p={[0, 0, 0]}
      mt="32px"
    >
      <Box
        bg="white"
        p={["32px 24px", "32px 24px", "40px 22px"]}
        //   mt={["24px", "10px"]}
        borderRadius={[0, "8px", "16px"]}
      >
        <AffiliateWallet
          coin={coin}
          availableCoins={[coin]}
          balance={balance}
          precision={8}
          forcePrecision
          onPayback={() => history.push(`/dashboard/wallet/${coin}/withdraw`)}
        />

        <AffiliateTransactions
          page={state?.page}
          limit={state?.limit}
          totalCount={totalCount}
          isLoading={isLoading}
          isFetching={isFetching}
          transactions={earnings}
          mt="40px"
          onNextPage={(next) => setState({ page: next })}
          onFilter={(filter) => setState({ ...filter })}
        />
      </Box>
    </Container>
  );
}
